import React from 'react'
import { Link } from 'gatsby'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Socials from './socials'
import Year from './year'

export default function Footer() {
    return (
        <Container
            fluid
            className='bg-black text-white border-top border-primary border-2'
        >
            <Container className='py-5'>
                <Row
                    className='justify-content-between'
                    style={{ gap: 32 }}
                >
                    <Col>
                        <Row
                            className='align-items-center'
                            css={{
                                gap: 40,
                                '@media(max-width: 992px)': { gap: 20 }
                            }}
                        >
                            <Col xs='auto'>
                                <Link to='/'>
                                    <img
                                        src='/svg/bfd-logo-white.svg' alt=''
                                        height={40}
                                    />
                                </Link>
                            </Col>
                            <Col xs='auto'>
                                <Socials keyHelper='footer' />
                            </Col>
                        </Row>
                        <div
                            className='d-flex flex-wrap'
                            style={{
                                marginTop: 12,
                                fontSize: 12,
                                gap: 10,
                            }}
                        >
                            <span>© <Year /> inMusic, LLC. All Rights Reserved.</span>

                            <a href="https://www.plugivery.com/about/dealers" target="_blank" rel="noreferrer" className='text-white text-decoration-none'>Dealers</a>
                            <span>|</span>

                            <a href="https://support.bfddrums.com/en/support/home" target="_blank" rel="noreferrer" className='text-white text-decoration-none'>Support</a>
                            <span>|</span>

                            <Link to='/downloads' className='text-white text-decoration-none'>Downloads</Link>
                            <span>|</span>

                            <a href="https://www.inmusicbrands.com/careers" target="_blank" rel="noreferrer" className='text-white text-decoration-none'>Careers</a>
                            <span>|</span>

                            <Link href='/privacy' className='text-white text-decoration-none'>Privacy</Link>
                            <span>|</span>

                            <Link to='/refund-policy' className='text-white text-decoration-none'>Refund Policy</Link>
                            <span>|</span>

                            <Link to='/terms-of-use' className='text-white text-decoration-none'>Terms of Use</Link>
                            <span>|</span>
                            
                            <Link to='/about-us' className='text-white text-decoration-none'>About us</Link>
                            <span>|</span>

                            <div id="teconsent" className='d-inline text-decoration-none' />
                        </div>
                    </Col>
                    <Col xs={12} md='auto' className='text-xl-end mt-xl-0'>
                        <a href="https://inmusicbrands.com" rel='noreferrer' target='_blank'>
                            <img src='/svg/inmusic-logo-white.svg' alt='' />
                        </a>
                        <p
                            className='mb-0'
                            style={{ fontSize: 14, marginTop: 12 }}
                        >
                            Part of the inMusic family of brands
                        </p>
                    </Col>
                </Row>
            </Container>
        </Container>
    )
}